import React from 'react';

/**
 * Dashboard panel: title on the left, a count pill at the top-right.
 *
 * Used for the "Assigned to me / my team" lists and the chart cards so
 * every dashboard surface shows the same pending-task / pending-
 * complaint number in the same corner.
 */
export default function DashboardCard({
  title,
  count,
  countLabel,
  children,
  divider = true,
}) {
  const hasCount = count != null && count !== '';
  const label = countLabel || String(count ?? '');

  return (
    <section className="ty-card">
      <header className="ty-card__head">
        <h3 className="ty-card__title">{title}</h3>
        {hasCount && (
          <span
            className="ty-card__count"
            title={label}
            aria-label={label}
          >
            {count}
          </span>
        )}
      </header>
      {divider && <hr className="ty-card__rule" />}
      <div className={divider ? undefined : 'ty-card__body'}>
        {children}
      </div>
    </section>
  );
}
